import axios from "axios";
import React, { Component } from "react";
import { AppVariant } from "src/config/appVariants";
import { TOKEN_TYPE } from "src/constants/tokenType";
import { LoginType, RegionalApiManager } from "src/scenes/App";
import { AuthDescription, AuthSurface, AuthTitle } from "./AuthComponents";
import LottieLoadingIndicator from "./LottieLoadingIndicator";
import SignUpContainer from "./SignUpContainer";

class ResetPasswordContainer extends Component {
    state = {
        appVariant: this.props.match.params.portal === "app" ? null : AppVariant.ME_BUSINESS,
        errorMessage: "",
        loading: this.props.match.params.portal === "app"
    };

    componentDidMount() {
        if (this.props.match.params.portal === "app") {
            this.loadAppVariant();
        }
    }

    loadAppVariant = async () => {
        try {
            const token = this.props.match.params.token;
            const regionData = await RegionalApiManager.locateUser(LoginType.ShortTermToken, token);
            RegionalApiManager.setRegionData(regionData);
            const response = await axios.get(
                `${regionData.apiUrl}/validateShortTermKey/${token}/${TOKEN_TYPE.FORGOT_PASSWORD}`
            );
            this.setState({ appVariant: response.data.appVariant });
        } catch (error) {
            this.setState({
                errorMessage: error.getApiErrorDetails?.().message || "This reset-password link is invalid or expired."
            });
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { children } = this.props;
        const { appVariant, errorMessage, loading } = this.state;

        return (
            <SignUpContainer appVariant={appVariant}>
                {loading && <LottieLoadingIndicator />}
                {!loading && errorMessage &&
                    <AuthSurface>
                        <AuthTitle>Reset Link Unavailable</AuthTitle>
                        <AuthDescription>{errorMessage}</AuthDescription>
                    </AuthSurface>
                }
                {!loading && !errorMessage && children}
            </SignUpContainer>
        );
    }
}

export default ResetPasswordContainer;
